import { Navigate } from 'react-router-dom';
import { AllowedEmailsPanel } from '../components/settings/AllowedEmailsPanel';
import { SharePointEnquiryPanel } from '../components/settings/SharePointEnquiryPanel';
import { PageHeader } from '../components/ui/PageHeader';
import { useAuth } from '../contexts/AuthContext';
import { useCrmData } from '../contexts/CrmDataContext';
import { canManageSharePointSettings } from '../lib/settingsPermissions';

function roleBadgeClass(role: string): string {
  if (role === 'it') return 'settings-role-badge settings-role-badge--it';
  if (role === 'admin') return 'settings-role-badge settings-role-badge--admin';
  if (role === 'supervisor') return 'settings-role-badge settings-role-badge--supervisor';
  if (role === 'management') return 'settings-role-badge settings-role-badge--management';
  return 'settings-role-badge settings-role-badge--user';
}

import { usePortalPath } from '../contexts/PortalContext';

export function SettingsPage() {
  const home = usePortalPath();
  const { profile } = useAuth();
  const { canViewSettings } = useCrmData();
  const showSharePoint = canManageSharePointSettings(profile?.role ?? 'user');

  if (!canViewSettings) {
    return <Navigate to={home} replace />;
  }

  const displayName = profile?.display_name?.trim() || profile?.username || 'User';
  const email = profile?.email ?? '—';
  const role = profile?.role ?? 'user';

  return (
    <div className="settings-page">
      <PageHeader
        title="Settings"
        description="Manage team access, roles, and who can sign in to CRM."
      />

      <section className="card settings-profile-card">
        <div className="settings-profile-card__avatar" aria-hidden>
          {displayName[0]?.toUpperCase() ?? '?'}
        </div>
        <div className="settings-profile-card__info">
          <p className="settings-profile-card__eyebrow">Your session</p>
          <h2 className="settings-profile-card__name">{displayName}</h2>
        </div>
        <p className="settings-profile-card__email">{email}</p>
        <div className="settings-profile-card__meta">
          <span className={roleBadgeClass(role)}>{role}</span>
          {profile?.username && (
            <span className="settings-profile-card__username">@{profile.username}</span>
          )}
        </div>
      </section>

      <AllowedEmailsPanel />
      {showSharePoint && <SharePointEnquiryPanel />}
    </div>
  );
}
